/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ВНИМАНИЕ! Это копия AnalyticsUserPlatform из Gc/Dnl - надо при обновлении добавлять и туда
 *
 * ВНИМАНИЕ! Публичная информация! После изменения не забудьте обновить README.md
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesNativePlatform;
(function (FxIdDomainEntitiesNativePlatform) {
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["Unspecified"] = 0] = "Unspecified";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["Editor"] = 1] = "Editor";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AppStore"] = 2] = "AppStore";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidGooglePlay"] = 3] = "AndroidGooglePlay";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidDigicaviar"] = 4] = "AndroidDigicaviar";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidAmazon"] = 5] = "AndroidAmazon";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["StandaloneSteamWin"] = 6] = "StandaloneSteamWin";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["StandaloneSteamMacos"] = 7] = "StandaloneSteamMacos";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["StandaloneWindowsStore"] = 8] = "StandaloneWindowsStore";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["StandaloneMailRu"] = 9] = "StandaloneMailRu";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidRuStore"] = 10] = "AndroidRuStore";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidAppBazar"] = 11] = "AndroidAppBazar";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlUnspecified"] = 12] = "WebGlUnspecified";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlFxId"] = 13] = "WebGlFxId";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlVkontaktePlay"] = 14] = "WebGlVkontaktePlay";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlOdnoklassniki"] = 15] = "WebGlOdnoklassniki";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlVkontakteCom"] = 16] = "WebGlVkontakteCom";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlYandexGames"] = 17] = "WebGlYandexGames";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlAbsoluteGames"] = 18] = "WebGlAbsoluteGames";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlKongregate"] = 19] = "WebGlKongregate";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["StandaloneReplayChecker"] = 20] = "StandaloneReplayChecker";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlFacebookGames"] = 21] = "WebGlFacebookGames";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidSamsung"] = 22] = "AndroidSamsung";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["StandaloneWindowsDesktop"] = 23] = "StandaloneWindowsDesktop";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["Browser"] = 24] = "Browser";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["BrowserIos"] = 25] = "BrowserIos";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["BrowserAndroid"] = 26] = "BrowserAndroid";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["BrowserWindows"] = 27] = "BrowserWindows";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["BrowserLinux"] = 28] = "BrowserLinux";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["BrowserMacOs"] = 29] = "BrowserMacOs";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidOneStore"] = 30] = "AndroidOneStore";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AndroidEgs"] = 31] = "AndroidEgs";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["AppStoreEgs"] = 32] = "AppStoreEgs";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["WebGlCrazyGames"] = 33] = "WebGlCrazyGames";
    FxIdDomainEntitiesNativePlatform[FxIdDomainEntitiesNativePlatform["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesNativePlatform || (FxIdDomainEntitiesNativePlatform = {}));
export function instanceOfFxIdDomainEntitiesNativePlatform(value) {
    for (const key in FxIdDomainEntitiesNativePlatform) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesNativePlatform, key)) {
            if (FxIdDomainEntitiesNativePlatform[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesNativePlatformFromJSON(json) {
    return FxIdDomainEntitiesNativePlatformFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesNativePlatformFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesNativePlatformToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesNativePlatformToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesNativePlatform.js.map